import React, { useState } from "react";

const Tooltip = ({ message, children }) => {
	const [visible, setVisible] = useState(false);

	const showTooltip = () => {
		setVisible(true);
		setTimeout(() => setVisible(false), 1500); // Tooltip disappears after 1.5 seconds
	};

	return (
		<div className="tooltip-container" onClick={showTooltip}>
			{children}
			{visible && <div className="tooltip">{message}</div>}
		</div>
	);
};

export default Tooltip;
